// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.vs__selected-options, .vs__selected {\n  padding-left: 5px !important;\n}\n", ""]);
// Exports
module.exports = exports;
